import React from 'react';
import { FormattedMessage } from 'react-intl';

import Perks from 'app/features/pricingPromo/landing/components/megaFanPerks/perks';
import { Styled } from 'app/features/pricingPromo/landing/components/megaFanPerks/MegaFanPerks.styled';
import Heading from 'app/components/layout/Heading.styled';

const MegaFanPerks = () => (
  <Styled.MegaFanPerks data-t="mega-fan-perks-section">
    <Heading isFixedSize size="xxs" as={Styled.Title}>
      <FormattedMessage id="pricing_promo_landing_perks_heading" />
    </Heading>
    <Perks />
  </Styled.MegaFanPerks>
);

MegaFanPerks.displayName = 'MegaFanPerks';

export default MegaFanPerks;
